import { render } from "./StockReport.vue?vue&type=template&id=796cef4e&scoped=true"
import script from "./StockReport.vue?vue&type=script&lang=js"
export * from "./StockReport.vue?vue&type=script&lang=js"

import "./StockReport.vue?vue&type=style&index=0&id=796cef4e&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796cef4e"]])

export default __exports__